module.exports = __webpack_public_path__ + "img/pasos1-5.f510c806.png";